module.exports = __webpack_public_path__ + "static/img/home_logo.3e55b73f.png";